import type { LimitStatus } from '@growup/arena-shared';
import type { StatusTone } from '@growup/ui';

const time = new Intl.DateTimeFormat('pt-PT', {
  timeZone: 'Europe/Lisbon',
  hour: '2-digit',
  minute: '2-digit',
});
const dateTime = new Intl.DateTimeFormat('pt-PT', {
  timeZone: 'Europe/Lisbon',
  dateStyle: 'short',
  timeStyle: 'short',
});

const date = new Intl.DateTimeFormat('pt-PT', { timeZone: 'Europe/Lisbon', dateStyle: 'short' });

export const formatTime = (iso: string) => time.format(new Date(iso));
export const formatDate = (iso: string) => date.format(new Date(iso));
export const formatDateTime = (iso: string) => dateTime.format(new Date(iso));

export function formatMinutes(total: number): string {
  const m = Math.max(0, Math.round(total));
  const h = Math.floor(m / 60);
  return h > 0 ? `${String(h)}h${String(m % 60).padStart(2, '0')}` : `${String(m)} min`;
}

export function minutesUntil(iso: string, now: number): number {
  return (new Date(iso).getTime() - now) / 60_000;
}

/**
 * How a limit state is shown. Never by colour alone: each state has its own
 * symbol and words (rule carried over from the Arena's first panel).
 */
export const LIMIT_LOOK: Record<
  LimitStatus['state'],
  { symbol: string; label: string; tone: StatusTone }
> = {
  idle: { symbol: '○', label: 'Livre', tone: 'neutral' },
  on_break: { symbol: '⏸', label: 'Em pausa', tone: 'info' },
  ok: { symbol: '✓', label: 'Dentro do limite', tone: 'success' },
  warning: { symbol: '!', label: 'Perto do limite', tone: 'warning' },
  over_continuous: { symbol: '✕', label: 'Passou 1h30 seguida', tone: 'danger' },
  over_daily: { symbol: '✕', label: 'Passou o limite do dia', tone: 'danger' },
};

/** The "in a row" label follows the arena's policy instead of a fixed 1h30. */
export function limitLabel(status: LimitStatus): string {
  if (status.state === 'over_continuous') {
    return `Passou ${formatMinutes(status.continuousLimitMinutes)} seguida`;
  }
  return LIMIT_LOOK[status.state].label;
}
